import Flickity from 'flickity'
import { $, each } from '../util'

const EventsPreview = (() => {
  const init = () => {
    const container = $('.js-events-previews-slider-container')

    each(container, (i, ct) => {
      const eventsSlider = ct.querySelector('.js-events-preview-slider')
      const slides = ct.querySelectorAll('.js-events-preview-slide')
      const progressBar = ct.querySelector('.js-events-previews-slider-progress')

      const prev = ct.querySelector('.js-slider-prev')
      const next = ct.querySelector('.js-slider-next')

      const evsInstance = new Flickity(eventsSlider, {
        cellSelector: '.js-events-preview-slide',
        cellAlign: 'left',
        pageDots: false,
        freeScroll: false,
        prevNextButtons: false,
        wrapAround: false,
        draggable: true,
      })

      if (progressBar) {
        progressBar.style.width = `${(1 / slides.length) * 100}%`

        evsInstance.on('select', (index) => {
          const ourProgress = (index + 1) / slides.length

          progressBar.style.width = `${ourProgress * 100}%`
        })
      }
      if (next) {
        next.addEventListener('click', (e) => {
          e.preventDefault()
          
          evsInstance.next()
        })
      }
      if (prev) {
        prev.addEventListener('click', (e) => {
          e.preventDefault()
          
          evsInstance.previous()
        })
      }
    })
  }

  return {
    init,
  }
})()

export default EventsPreview



// WEBPACK FOOTER //
// app/javascript/scripts/components/EventsPreviews.js